import { render, staticRenderFns } from "./ArchiveHeatmap.vue?vue&type=template&id=ec66b86a&scoped=true&"
import script from "./ArchiveHeatmap.vue?vue&type=script&lang=js&"
export * from "./ArchiveHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveHeatmap.vue?vue&type=style&index=0&id=ec66b86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec66b86a",
  null
  
)

export default component.exports